import clsx from 'clsx'
import { FullLoader } from 'components/atoms/FullLoader/FullLoader.tsx'
import { useEffect, useState } from 'react'
import { useAutomationEnded } from 'shared/connector/hooks.ts'
import { notifyError } from 'shared/errors/notificate.ts'
import { useAppSelector } from 'shared/hooks/store.ts'
import { typo } from 'shared/styles'

import { activity } from '../../actions/activity.js'
import { refetchCampaigns } from '../../actions/campaign.js'
import ExceededLimitNotification from '../../components/atoms/ExceededLimitNotification/index.js'
import WorkingHoursNotification from '../../components/atoms/WorkingHoursNotification/index.js'
import TableActivity from '../../components/molecules/tableActivity/index.js'
import { appSelectors } from '../../redux/reducers/app.ts'
import css from './ActivityPage.module.scss'

export function ActivityPage() {
	const connector = useAppSelector(appSelectors.connector),
		isLoading = useAppSelector(state => state.app.pageContentLoader),
		persona = useAppSelector(appSelectors.persona)

	const [isInWorkHours, setIsInWorkHours] = useState<boolean | null>(null)

	async function getWorkingHours() {
		try {
			const workingHours = await connector.automation.isInWorkingHours()
			setIsInWorkHours(workingHours)
		} catch (error) {
			notifyError(error)
			setIsInWorkHours(true)
		}
	}

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		getWorkingHours()
		// TODO: Replace fetch campaign to RTK Query
		activity.getActivities()
	}, [])

	useAutomationEnded(() => {
		refetchCampaigns()
		activity.getActivities(true)
	})

	return (
		<main
			className={clsx(
				css.root,
				'main app-scroll',
				!isLoading && css.withContent
			)}
		>
			{isLoading && <FullLoader size={60} />}
			{!isLoading && (
				<>
					<h1 className={clsx(css.title, typo.mediumBody)}>Activities queue</h1>

					{persona?.exceedLinkedInInvitationsLimit ? (
						<ExceededLimitNotification>
							<span>
								The weekly limit for sending invitations has been exceeded
							</span>
						</ExceededLimitNotification>
					) : (
						!isInWorkHours &&
						isInWorkHours !== null && (
							<WorkingHoursNotification>
								<span>The activities will starts upon your working hours</span>
							</WorkingHoursNotification>
						)
					)}

					<TableActivity
						checkboxs={false}
						classesContainer={'activity-container'}
						showSteps={false}
						type='activity'
					/>
				</>
			)}
		</main>
	)
}
